import {Button} from "antd";
import {ArrowDownIcon, HorizontalDots} from "@/theme/assets/icons";
import {Popover} from "antd";

export const OptionsButton = (
    {
        type='arrow',
        content,
        placement = 'bottomRight',
        disabled = false,
        ...rest
    }
) => {
    return (
        <>
            <Popover
                rootClassName={'options_button'}
                content={disabled ? null : content}
                trigger="click"
                placement={placement}
                arrow={false}
                {...rest}
            >
                <Button
                    type="text"
                    icon={type === 'arrow' ? <ArrowDownIcon /> : <HorizontalDots />}
                    disabled={disabled}
                />
            </Popover>
        </>
    );
}